export const LAW_BASE_PATH = 'lover-og-lovkommentarer'
export const LAW_PARAGRAPH_TEXT = 'paragraf'
export const DOWNLOAD_MAX_ITEMS = 150
// Use login time (`session.createdAt`) for cookie expiry and the server age check, so refresh doesn't extend it.
// Keep it within AM's refresh-token lifetime otherwise the cookie outlives the token.
export const SESSION_MAX_AGE_SECONDS = 60 * 60 * 24 * 28
export const YEAR_PATTERN = /^\d{4}$/

// These EAN lists serve different purposes but overlap. Keep them together so changes are visible
// and covered by the subset test in constants.test.ts.

// FIXME: Move these to the content metadata in Ibexa.
export const EAN_NOT_DOWNLOADABLE_PROD = ['894322879', '894322900', '894322901', '894322876']
export const EAN_NOT_DOWNLOADABLE_NON_PROD = ['894322874', '18312000010']

// Intentionally shared across environments so the access check can be tested outside production.
export const EAN_STUDENT_RESTRICTED = ['894322876', '894322901']
